/**
 * src/utils/nexo.js
 * Utilidades para integración con Nexo (iframe admin de Tiendanube)
 */

/**
 * Abre una URL externa de forma segura usando Nexo si está disponible,
 * o fallback a window.open si no estamos en el admin de Tiendanube
 * @param {string} url - URL a abrir
 * @param {string} [target='_blank'] - Target para window.open fallback
 */
export const openExternal = (url, target = '_blank') => {
  // Primero verificamos si tenemos acceso a Nexo (estamos en admin Tiendanube)
  if (window.nexo) {
    console.log('[Nexo] Abriendo URL externa a través de nexo.openExternal:', url);
    // Usamos la API oficial de Nexo para abrir URLs externas de forma segura
    window.nexo.openExternal({ url });
    return;
  }
  
  // Si no estamos en Tiendanube, usamos el navegador normal
  console.log('[Nexo] Nexo no detectado, abriendo URL vía window.open:', url);
  window.open(url, target);
};

/**
 * Ajusta el tamaño del iframe dentro del admin de Tiendanube
 * @param {number} height - Altura en píxeles
 */
export const resize = (height) => {
  if (window.nexo) {
    console.log('[Nexo] Ajustando altura del iframe a:', height, 'px');
    window.nexo.resize({ height });
  }
};

/**
 * Muestra un toast/alerta nativa del admin de Tiendanube
 * @param {object} options - Opciones del mensaje
 * @param {string} options.message - Texto a mostrar
 * @param {string} options.type - Tipo: success, info, warning, error
 */
export const showToast = ({ message, type = 'info' }) => {
  if (window.nexo) {
    console.log('[Nexo] Mostrando toast:', { message, type });
    window.nexo.showToast({ message, type });
  } else {
    // Fallback si no estamos en Tiendanube
    console.log('[Nexo] Toast (fuera de Nexo):', message);
    alert(message);
  }
};

/**
 * Detecta si la aplicación está corriendo embebida en el admin de Tiendanube
 * @returns {boolean} true si está en iframe de Tiendanube
 */
export const isEmbedded = () => {
  return window !== window.parent && window.nexo !== undefined;
};

/**
 * Inicializa los listeners de Nexo para eventos de navegación y otros
 * @param {Function} onNavigate - Callback para eventos de navegación
 */
export const initNexoListeners = (onNavigate) => {
  if (window.nexo) {
    console.log('[Nexo] Inicializando listeners de eventos Nexo');
    
    // Escuchar eventos de navegación del admin
    window.nexo.onNavigate(({ path }) => {
      console.log('[Nexo] Evento onNavigate recibido:', path);
      if (typeof onNavigate === 'function') {
        onNavigate(path);
      }
    });
    
    // Podemos añadir más listeners según necesidades
  }
};
